// removed by extract-text-webpack-plugin
module.exports = {"table":"due_","row":"_34v_"};


//////////////////
// WEBPACK FOOTER
// ./src/features/MobileServices/MobileServiceForm/AvailablePremiumNumbers/AvailablePremiumNumbers.scss
// module id = Aol2
// module chunks = 0